import {observer} from 'mobx-react-lite';
import {BarChartColumn, Table} from '@/components/common-components/components';
import {ColumnsType} from 'antd/lib/table';
import {isNil} from 'lodash';
import {formatNumber} from '@/utils/number';
import styled from 'styled-components';
import {useStore} from '@/store/root-store';
import {graphic} from 'echarts';
import moment from 'moment';
import {Tooltip, Divider} from 'antd';
import {EmptyStateKeDetail} from './emptyStateKe';
import {UrlDropdown} from './commonUrlDropdown';
import {getDomain, getSingleUrlParam, isPublicKeywordResearcherV2} from '@/utils/url';
import {PublicPageBanner} from '../../ke-common-components/publicPageBanner';
import {linkgraphDomains} from '@/utils/router';
import {useEffect, useState} from 'react';

export const AdvertisersTable = observer(() => {
  const {keywordResearcherV2: {keywordDetails: {getKeywordDetailsData, getOrganicPaidHistoryData, loadingOrganicPaidHistoryDetails}}} = useStore('');
  const countryCode = getSingleUrlParam('countryCode') || getKeywordDetailsData?.countryCode;
  const currentDomain = getDomain(window.location.hostname);
  const isWhiteLabelDomain = !linkgraphDomains.includes(currentDomain);
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const data = getOrganicPaidHistoryData?.paidRankings?.adHistory;
  const adsHeader = [];
  if (data?.length) {
    data?.map(item => {
      item?.ads?.map(z => {
        if (!adsHeader?.includes(z?.searchDate)) {
          adsHeader.push(z?.searchDate);
        }
      });
    });
  }
  const adsHeaderSorted = adsHeader?.sort();

  const columns: ColumnsType = [{
    title: () => <span>DOMAIN</span>,
    key: 'domain',
    dataIndex: 'domain',
    width: 300,
    fixed: screenWidth >= 800 ? 'left' as 'left' : false,
    render: (_, data: any, index) => {
      return <OverLay blurred={index > 4 && isPublicKeywordResearcherV2()}>
        <UrlDropdown url={data?.domain} text={data?.domain} countryCode={countryCode} isPublicPage={isPublicKeywordResearcherV2()}/>
      </OverLay>;
    },
  },
  {
    title: () => <div>
      <span>MONTHLY</span><br/>
      <span>BUDGET</span>
    </div>,
    key: 'budget',
    dataIndex: 'budget',
    align: 'right',
    width: 100,
    sorter: (a: any, b: any)=> a?.budget-b.budget,
    render: (_, data: any, index) => <CellWrapper blurred={index > 4 && isPublicKeywordResearcherV2()}>
      {!isNil(data?.budget) ? '$'+formatNumber(data?.budget) : '-'}</CellWrapper>,
  },
  {
    title: () => <div>
      <span>TOTAL</span><br/>
      <span>KEYWORDS</span>
    </div>,
    key: 'totalKeywords',
    dataIndex: 'totalKeywords',
    align: 'right',
    width: 120,
    sorter: (a: any, b: any) => a?.totalKeywords - b?.totalKeywords,
    render: (_, data: any, index) => <CellWrapper blurred={index > 4 && isPublicKeywordResearcherV2()}>
      {!isNil(data?.totalKeywords) ? formatNumber(data?.totalKeywords) : '-'}</CellWrapper>,
  },
  {
    title: () => <div>
      <span>TOP OF</span><br/>
      <span>PAGE</span>
    </div>,
    key: 'topOfPage',
    dataIndex: 'topOfPage',
    align: 'right',
    width: 90,
    sorter: (a: any, b: any) => a?.topOfPage - b?.topOfPage,
    render: (_, data: any, index) => <CellWrapper blurred={index > 4 && isPublicKeywordResearcherV2()}>
      {!isNil(data?.topOfPage) ? formatNumber(data?.topOfPage) : '-'}</CellWrapper>,
  },
  {
    title: () => <span>ADS</span>,
    key: 'adCount',
    dataIndex: 'adCount',
    align: 'right',
    width: 70,
    sorter: (a: any, b: any) => a?.adCount - b?.adCount,
    render: (_, data: any, index) => <CellWrapper blurred={index > 4 && isPublicKeywordResearcherV2()}>
      {!isNil(data?.adCount) ? formatNumber(data?.adCount) : '-'}</CellWrapper>,
  },
  {
    title: () => <div style={{paddingLeft: '15px'}}>
      <span>AD</span><br/>
      <span>POSITION</span>
    </div>,
    key: 'ads',
    dataIndex: 'ads',
    align: 'left',
    width: 100,
    render: (_, data: any, index) => {
      const sortedArr = data?.ads?.sort((a, b) => Number(new Date(a.searchDate)) - Number(new Date(b.searchDate)));
      const dataArr = sortedArr?.map(item => item?.position);
      const xaxixData = sortedArr?.map(item=> item?.searchDate);
      if (xaxixData?.length==1) {
        xaxixData?.unshift(xaxixData[0]);
      }
      if (dataArr?.length == 1) {
        dataArr?.unshift(0);
      }
      const series = [{
        type: 'line',
        showSymbol: false,
        itemStyle: {
          color: '#2D6CCA',
        },
        areaStyle: {
          color: new graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: 'rgba(45, 108, 202, 0)',
          }, {
            offset: 0.9,
            color: '#fff',
          }]),
        },
        data: dataArr,
      }];

      return <ChartCellWrapper blurred={index > 4 && isPublicKeywordResearcherV2()}>
        {dataArr?.length ? <BarChartColumn grid={{left: 3, right: 3, top: 10, bottom: 0}} series={series} xaxixData={xaxixData} isAdsPosition={true}/> : '-'}
      </ChartCellWrapper>;
    },
  },
  {
    title: () => <HeaderDate>{adsHeaderSorted?.length ? adsHeaderSorted?.map((item, idx) => {
      return <div key={`adsHeader_${idx}`} style={{width: '3px', position: 'relative'}}>
        {(idx == 0 || idx == Math.round(adsHeaderSorted.length/2) || idx == adsHeaderSorted.length - 1) ? <span
          style={idx == 0 ? {position: 'absolute', left: 0} : {position: 'absolute', right: 0}}>{moment(item)?.format('DD MMM YYYY')}</span> : ''}
      </div>;
    }) : ''}</HeaderDate>,
    key: 'ads',
    dataIndex: 'ads',
    align: 'left',
    width: 350,
    render: (_, data: any, index) => {
      return <AdsWrapper blurred={index > 4 && isPublicKeywordResearcherV2()}>
        {adsHeaderSorted?.length ? adsHeaderSorted?.map(item => {
          const singleAdData = data?.ads?.find(z => z?.searchDate == item);
          return <>
            {singleAdData ? <Tooltip arrowContent={<></>} title={<div key={`ads_tooltip_${singleAdData?.searchDate}`}>
              <div style={{height: '90px'}}>
                <BoxTitle>{singleAdData?.title}</BoxTitle>
                <BoxLink href={singleAdData?.url}>{singleAdData?.url}</BoxLink>
                <Description dangerouslySetInnerHTML={{__html: singleAdData?.body}} />
              </div>
              <Divider type='horizontal' style={{background: '#E8E8E8', margin: '9px 0'}}/>
              <IndexDate>Indexed: {singleAdData?.searchDate ? moment(singleAdData?.searchDate)?.format('DD MMMM, YYYY') : ''}</IndexDate>
            </div>} color='#fff' overlayInnerStyle={{color: '#121212', borderRadius: '8px', padding: '12px'}} overlayStyle={{minWidth: '350px'}}>
              <div style={{width: '3px', background: '#2D6CCA', height: '20px', cursor: 'pointer'}}/>
            </Tooltip> : <div style={{width: '3px', background: 'transparent', height: '20px'}}/>}
          </>;
        }) : ''}
      </AdsWrapper>;
    },
  },
  ];

  return (
    <div>
      <TableContainer>
        {isPublicKeywordResearcherV2() && data?.length > 6 && <BannerDiv>
          <BannerContainer>
            <PublicPageBanner isInTable={true}/>
          </BannerContainer>
        </BannerDiv>}
        {loadingOrganicPaidHistoryDetails || data?.length ?
          <Table
            dataSource={data || []}
            columns={columns}
            pagination={false}
            loading={loadingOrganicPaidHistoryDetails}
            loadingRows={10}
            scroll={{y: 600}}
            rowClassName={(_, index) => isPublicKeywordResearcherV2() && !isWhiteLabelDomain && index > 4 ? 'bluredRowStyle' : ''}
          /> :
          <EmptyStateKeDetail imgText={'/img/backgroundfasearch.svg'} icon={true} text={'Competitor ads data is unavailable or missing.'} description = {'Data not found.'}/>

        }
      </TableContainer></div>
  );
});

const HeaderDate = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  font-weight: 400;
  margin-bottom: 8px;
`;
const BannerDiv = styled.div`
  position: relative;
  width: 1px;
  margin: auto;
  left: -50px;
`;

const AdsWrapper = styled.div<{blurred?: boolean}>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  ${p => p.blurred ? `filter: blur(10px);
    pointer-events: none;` : ''}
`;

const CellWrapper = styled.div<{blurred?: boolean}>`
  display: flex;
  align-items: center;
  justify-content: end;
  justify-content: center;
  ${p => p.blurred ? `filter: blur(10px);
    pointer-events: none;` : ''}
`;

const OverLay = styled.div<{blurred?: boolean}>`
  ${p => p.blurred ? `filter: blur(10px);
    pointer-events: none;` : ''}
`;

const BannerContainer = styled.div`
  position: absolute;
  width: 690px;
  top: 358px;
  left: -290px;
  z-index: 9;
`;

const ChartCellWrapper = styled.div<{blurred?: boolean}>`
  width: 100px;
  height: 50px;
  ${p => p.blurred ? `filter: blur(10px);
    pointer-events: none;` : ''}
`;

const TableContainer = styled.div`
 padding-bottom: 0 !important;
 position: relative;

 .bluredRowStyle {
  filter: blur(10px);
  pointer-events: none;
 }

 .ant-table-body {
  &::-webkit-scrollbar {
      height: 5px;
      width: 5px;
    }
  
    &::-webkit-scrollbar-thumb {
      background: rgba(138,138,138,0.32);
    }
  
    &::-webkit-scrollbar-track {
      background: rgba(138,138,138,0.12);
    }
}

table tr th {
  background-color: #fff;
}

.ant-table-content {
  border-radius: 0 !important;
}

.ant-table-column-sorters-with-tooltip:not(:first-child) {
  text-align: center;
}

table {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;

  th::before {
    width: 0 !important;
  }

  .ant-table-column-sorter {
    display: flex;
    margin-left:8px !important;
    width:40px !important;
    // padding-left: 3px !important;
  }

  .ant-table-column-sorters {
    display: inline-flex !important;
    // padding: 5px !important;
  }

  tr td {
    &:first-child {
      padding-bottom: 0 !important;
      padding-top: 0 !important;
    }
  }

  .ant-table-tbody {
    tr:nth-child(even) {
      td {
        background: #fff !important;
        border-bottom: 1px solid #f4f4f4 !important;
        box-shadow: none;
        font-weight: 400;
        white-space: nowrap;
      }

      &:hover {
        td {
          background: #eef4fe !important;
        }

        button {
          background: #eef4fe !important;
          border: 0 !important;
          color: #2d6cca;
          font-weight: 500;
        }
      }
    }

    tr:nth-child(odd) {
      td {
        background: #fff;
        border-bottom: 1px solid #f4f4f4 !important;
        box-shadow: none;
        font-weight: 400;
        white-space: nowrap;
      }

      &:hover {
        td {
          background: #eef4fe !important;
        }

        button {
          background: #eef4fe !important;
          border: 0 !important;
          color: #2d6cca;
          font-weight: 500;
        }
      }
    }
  }

  .ant-table-thead {
    background: #f7f7f7 !important;

    th {
      background: #f7f7f7 !important;
      color: #121212 !important;
      font-size: 12px;
      font-weight: 600;
      line-height: 14px;
      padding: 0 !important;
    }

    .ant-table-cell-fix-left {
      text-align: left !important;

      &:first-child {
        border-bottom-left-radius: 8px !important;
        border-top-left-radius: 8px !important;
      }
    }

    th:first-child {
      background: #f7f7f7 !important;
      border-bottom-left-radius: 8px !important;
      border-top-left-radius: 8px !important;
      color: #121212;
      font-size: 12px;
      font-weight: 600;
    }

    th:nth-child(2) {
      background: #f7f7f7 !important;
      color: #121212;
      font-size: 12px;
      font-weight: 600;
    }

    th:last-child {
      background-color: #f7f7f7 !important;
      border-bottom-right-radius: 8px !important;
      border-top-right-radius: 8px !important;
      padding-left: 25px !important;
    }
  }

  .ant-table-cell-fix-left-last {
    text-align: left !important;
  }

  tr:first-child td {
    background: #fff !important;
  }

  tr:nth-child(even) td {
    background: #f9f9fb !important;
  }

  tr:nth-child(odd) td {
    background-color: #fff !important;
  }

  tr th {
    height: 50px !important;
    line-height: 22px;
    white-space: nowrap;
  }

  .ant-column-sorters {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  tr td {
    padding-bottom: 15px;
    padding-top: 15px;
    text-align: center;
  }

  tr th:first-child,
  tr td:first-child {
    padding-left: 25px !important;
    padding-right: 25px !important;
  }
}
`;

const BoxTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #144198;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const BoxLink = styled.a`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #0C872F;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  white-space: nowrap;
  margin-top: 3px;
`;

const Description = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #4E5156;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  margin-top: 9px;
`;

const IndexDate = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #4E5156;
  text-overflow: ellipsis;
  overflow: hidden;
`;
